import React, { useState } from 'react';

// Importing images for players and their hover states
// Attacker
import Anu from './Team/With BG/Anu James [Attacker].png';
import Mannat from './Team/With BG/Mannat Choudhary [Attacker].png';
import George from './Team/With BG/George Anthony [Attacker].png';
import Carlos from './Team/With BG/Carlos Berrios [Attacker].png';
// Hover Images
import AnuHover from './Team/Info/Anu James [Attacker].png';
import CarlosHover from './Team/Info/Carlos Berrios [Attacker].png';
import GeorgeHover from './Team/Info/George Anthony [Attacker].png';
import MuhammedHover from './Team/Info/Muhammed Jasim [Blocker].png';
import RijisHover from './Team/Info/Rijas K R [Blocker].png';
import AyushHover from './Team/Info/Ayush Kasnia [Blocker].png';
import AjayHover from './Team/Info/Ajay Kumar [Blocker].png';
import AljoHover from './Team/Info/Aljo Sabu [Libero].png';
import AnandHover from './Team/Info/Anand K [Libero].png';
import AvinashHover from './Team/Info/Avinash Choudhary [Setter].png';
import SaqlainHover from './Team/Info/Saqlain Tariq [Setter].png';
import MannatHover from './Team/Info/Mannat Choudhary [Attacker].png';
import AbhishekHover from './Team/Info/Abhishek Rajeev [Oppsite].png';
import JesusHover from './Team/Info/Jesus Chourio [Opposite].png';


// Blocker
import Ayush from './Team/With BG/Ayush Kasnia [Blocker].png';
import Muhammed from './Team/With BG/Muhammed Jasim [Blocker].png';
import Rijis from './Team/With BG/Rijas K R [Blocker].png';
import Ajay from './Team/With BG/Ajay Kumar [Blocker].png';

// Libero 
import Anand from './Team/With BG/Anand K [Blocker].png';
import Aljo from './Team/With BG/Aljo Sabu [Libero].png';


// Setter 
import Saqlain from './Team/With BG/Saqlain Tariq [Setter].png';
import Avinash from './Team/With BG/Avinash Choudhary [Setter].png';

// Opposite
import Abhishek from './Team/With BG/Abhishek Rajeev [Opposite].png';
import Jesus from './Team/With BG/Jesus Chourio [Opposite].png';

// Grid Item Component to display player info
const GridItem = ({ image, name, position, hoverImage, onHover }) => {
  return (
    <div className='relative flex flex-col items-center md:w-1/5 w-full mb-2 gap-4 mx-1'>
      <img 
        src={image} 
        alt={name} 
        className='z-10' 
        onMouseEnter={() => onHover({ name, position, hoverImage })}
        onMouseLeave={() => onHover(null)}
      />
      <span className='font-bold text-xl py-1 z-30'>{name}</span>
      <span className='font-semibold z-30'>{position}</span>
    </div>
  );
};

// Modal Box Component to display player hover image
const ModalBox = ({ player, isVisible, onClose }) => {
  if (!isVisible || !player) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white py-5 px-4 rounded-lg relative mx-auto">
        <button 
          className="absolute top-0 right-1 text-2xl font-bold cursor-pointer" 
          onClick={onClose}
        >
          &times;
        </button>
        
        <img src={player.hoverImage} alt={player.name} className="w-auto md:h-96 h-auto mb-4" />
        <h2 className="text-center font-bold text-xl mb-2">{player.name}</h2>
        <p className="text-center font-semibold">{player.position}</p>
      </div>
    </div>
  );
};

// Main Section for the Toofani Squad
const SectionToofaniSquad = () => {
  const [hoveredPlayer, setHoveredPlayer] = useState(null);
  const [isModalVisible, setModalVisible] = useState(false);

  let enterTimeout, leaveTimeout;

  // Handle hover event to show modal with debounce to prevent flickering
  const handleHover = (player) => {
    if (leaveTimeout) clearTimeout(leaveTimeout);

    if (player) {
      enterTimeout = setTimeout(() => {
        setHoveredPlayer(player);
        setModalVisible(true);
        console.log('Player hovered:', player); // Debugging line
      }, 500);  // small delay to smooth out the hover transition
    } else {
      clearTimeout(enterTimeout);  // Prevent hover from triggering after mouse leaves
      leaveTimeout = setTimeout(() => {
        setModalVisible(false);
        console.log('Hover left, closing modal'); // Debugging line
      }, 20000);
    }
  };

  // Arrays of player data
  const attackers = [
    { image: Mannat, name: 'Mannat Choudhary', position: 'Attacker', hoverImage: MannatHover },
    { image: Carlos, name: 'Carlos Berrios', position: 'Attacker', hoverImage: CarlosHover },
    { image: Anu, name: 'Anu James', position: 'Attacker', hoverImage: AnuHover },
    { image: George, name: 'George Anthony', position: 'Attacker', hoverImage: GeorgeHover },
  ];

  const blockers = [
    { image: Muhammed, name: 'Muhammed Jasim', position: 'Middle Blocker', hoverImage: MuhammedHover },
    { image: Rijis, name: 'Rijas K R', position: 'Middle Blocker', hoverImage: RijisHover },
    { image: Ayush, name: 'Aayush Kasnia', position: 'Middle Blocker', hoverImage: AyushHover },
    { image: Ajay, name: 'Ajay Kumar', position: 'Middle Blocker', hoverImage: AjayHover },
  ];

  const liberos = [
    { image: Anand, name: 'Anand K', position: 'Libero', hoverImage: AnandHover },
    { image: Aljo, name: 'Aljo Sabu', position: 'Libero', hoverImage: AljoHover },
  ];

  const setters = [
    { image: Saqlain, name: 'Saqlain Tariq', position: 'Setter', hoverImage: SaqlainHover },
    { image: Avinash, name: 'Avinash Choudhary', position: 'Setter', hoverImage: AvinashHover },
    
  ];

  const other = [
    { image: Abhishek, name: 'Abhishek Rajeev', position: 'Opposite', hoverImage: AbhishekHover },
    { image: Jesus, name: 'Jesus Chourio', position: 'Opposite', hoverImage: JesusHover },

  ];

  return (
    <section className='mb-6'>
      <h1 className='py-4 bg-[#ffbd00] text-center text-4xl font-bold'>Toofani Squad</h1>
      <div className='max-auto md:px-[8rem]'>

        {/* Attackers Section */}
        <h2 className='text-center md:text-4xl py-5 font-semibold text-[#3b0067] text-2xl'>Attacker</h2>
        <div className="flex flex-wrap justify-center gap-5">
          {attackers.map((player, index) => (
            <GridItem key={index} {...player} onHover={handleHover} />
          ))}
        </div>

        {/* Blockers Section */}
        <h2 className='text-center md:text-4xl py-5 font-semibold text-[#3b0067] text-2xl'>Blocker</h2>
        <div className="flex flex-wrap justify-center gap-5">
          {blockers.map((player, index) => (
            <GridItem key={index} {...player} onHover={handleHover} />
          ))}
        </div>

        {/* Liberos Section */}
        <h2 className='text-center md:text-4xl py-5 font-semibold text-[#3b0067] text-2xl'>Libero</h2>
        <div className="flex flex-wrap justify-center gap-5">
          {liberos.map((player, index) => (
            <GridItem key={index} {...player} onHover={handleHover} />
          ))}
        </div>

        {/* Setters Section */}
        <h2 className='text-center md:text-4xl py-5 font-semibold text-[#3b0067] text-2xl'>Setter</h2>
        <div className="flex flex-wrap justify-center gap-5">
          {setters.map((player, index) => (
            <GridItem key={index} {...player} onHover={handleHover} />
          ))}
        </div>

        {/* Other Position Section */}
        <h2 className='text-center md:text-4xl py-5 font-semibold text-[#3b0067] text-2xl'>Opposite</h2>
        <div className="flex flex-wrap justify-center gap-5">
          {other.map((player, index) => (
            <GridItem key={index} {...player} onHover={handleHover} />
          ))}
        </div>
      </div>

      {/* Modal for player hover */}
      <ModalBox 
        player={hoveredPlayer}
        isVisible={isModalVisible}
        onClose={() => setModalVisible(false)}
      />
    </section>
  );
};

export default SectionToofaniSquad;
